export default __webpack_public_path__ + "static/media/skip@3x.4058a672.png";